import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedFormField, {
  TransmedFormFieldInput,
} from "../../../../dtos/transmed/process/form/field";
import TransmedFormFieldApi from "../../../../api/transmed/form/field";

class TransmedProcessFormFieldReader extends ServiceReader {}

class TransmedProcessFormFieldServiceCreator extends ServiceCreator {
  public async field(
    title: string,
    subtitle: string,
    points: number,
    quantitative: boolean,
    unitSingular: string,
    unitPlural: string,
    subsectionId: number
  ): Promise<TransmedFormField> {
    return await new TransmedFormFieldApi().post(
      new TransmedFormFieldInput(
        title,
        subtitle,
        points,
        quantitative,
        unitSingular,
        unitPlural,
        subsectionId
      )
    );
  }
}

class TransmedProcessFormFieldServiceUpdater extends ServiceUpdater {
  public async field(
    id: number,
    title: string,
    subtitle: string,
    points: number,
    quantitative: boolean,
    unitSingular: string,
    unitPlural: string,
    subsectionId: number
  ): Promise<TransmedFormField> {
    return await new TransmedFormFieldApi().put(
      `${id}`,
      new TransmedFormFieldInput(
        title,
        subtitle,
        points,
        quantitative,
        unitSingular,
        unitPlural,
        subsectionId
      )
    );
  }
}
class TransmedProcessFormFieldServiceDeleter extends ServiceDeleter {
  public async field(id: number): Promise<void> {
    return await new TransmedFormFieldApi().delete(`${id}`);
  }
}

export default class TransmedProcessFormFieldService extends Service {
  public get read(): TransmedProcessFormFieldReader {
    return new TransmedProcessFormFieldReader();
  }
  public get create(): TransmedProcessFormFieldServiceCreator {
    return new TransmedProcessFormFieldServiceCreator();
  }
  public get update(): TransmedProcessFormFieldServiceUpdater {
    return new TransmedProcessFormFieldServiceUpdater();
  }
  public get delete(): TransmedProcessFormFieldServiceDeleter {
    return new TransmedProcessFormFieldServiceDeleter();
  }
}
